<template>
  <TopbarSpeedDial :buttons="buttons" :routeKey="routeKey"/>
</template>


<script>
/* @flow */
const TopbarSpeedDial = () =>
  import(/* webpackChunkName: "TopbarSpeedDial" */ '@/components/TopbarSpeedDial')

export default {
  name: 'EndDeviceSpeedDial',
  props: {
    routeName: {type: String, default: ''},
    routeKey: {type: String, default: ''},
  },
  data() {
    return {
      buttonsConfig: [
        {
          label: 'Provision new end-device',
          icon: 'add',
          colorClass: 'primary',
          showForEndDevicesScreen: true,
          to: 'new',
        },
        {
          label: 'Upload CSV of end-devices',
          icon: 'cloud_upload',
          colorClass: 'primary',
          showForEndDevicesScreen: true,
          to: 'upload',
        },
      ],
    }
  },
  computed: {
    buttons: function() {
      if (this.routeName.startsWith('EndDevices')) {
        return this.buttonsConfig.filter(btn => btn.showForEndDevicesScreen)
      } else {
        return this.buttonsConfig
      }
    },
  },
  components: {
    TopbarSpeedDial,
  },
}
</script>



// WEBPACK FOOTER //
// src/components/EndDeviceSpeedDial.vue